<template>
    <div class="min-h-screen bg-gray-50 p-8">
      <!-- 筛选条件区域 -->

  
      <!-- 数据概览区域 -->
      <div class="mb-8 grid grid-cols-5 gap-6">
        <div v-for="(stat, index) in statistics" :key="index" class="rounded-lg bg-white p-6 shadow-sm">
          <div class="mb-2 text-sm text-gray-500">{{ stat.label }}</div>
          <div class="flex items-end gap-2">
            <span class="text-2xl font-bold text-gray-800">{{ stat.value }}</span>
            <span v-if="stat.unit" class="text-sm text-gray-500">{{ stat.unit }}</span>
          </div>
        </div>
      </div>
  
      <!-- 图表区域 -->
      <div class="mb-8 grid grid-cols-2 gap-6">
        <div class="rounded-lg bg-white p-6 shadow-sm">
          <h3 class="mb-4 text-lg font-medium text-gray-800">订单趋势</h3>
          <div ref="orderTrendChart" style="height: 300px"></div>
        </div>
        <div class="rounded-lg bg-white p-6 shadow-sm">
          <h3 class="mb-4 text-lg font-medium text-gray-800">支付类别分布</h3>
          <div ref="categoryChart" style="height: 300px"></div>
        </div>
      </div>
  
      <!-- 表格区域 -->
      <div class="rounded-lg bg-white shadow-sm">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column prop="order_no" label="订单号"></el-table-column>
            <el-table-column prop="linkname" label="姓名"></el-table-column>
             <el-table-column prop="phone" label="手机号"></el-table-column>
           
            <!-- <el-table-column prop="or_price" label="原支付金额"></el-table-column>
             <el-table-column prop="dk_price" label="抵扣金额"></el-table-column> -->
              <el-table-column prop="pay_price" label="支付金额"></el-table-column>
                 <el-table-column prop="pay_status" label="支付状态">
              <template #default="scope">
                {{ getPayStatusText(scope.row.pay_status) }}
              </template>
            </el-table-column>
                <el-table-column prop="address" label="详细地址"></el-table-column>
           
            <!-- <el-table-column 
              prop="is_refund" 
              label="退款"
              :formatter="(row) => ({
                0: '未申请退款',
                1: '申请退款',
                2: '申请退款审核通过',
                3: '申请退款审核不通过'
              }[row.is_refund] || row.is_refund)">
            </el-table-column>
            <el-table-column prop="canel_val" label="取消退款原因"></el-table-column> -->
          
            <el-table-column prop="create_time" label="创建时间"></el-table-column>
          
            <el-table-column label="操作" width="120" fixed="right">
              <template #default="scope">
                <el-button
                  v-if="scope.row.is_refund === 0 || scope.row.is_refund === 1 || scope.row.is_refund === 3"
                  type="text"
                  size="small"
                  @click="handleRefund(scope.row)">
                  退款
                </el-button>
                <span v-if="scope.row.is_refund === 2">已退款</span>
                   <el-button
        type="text"
        size="small"
        style="color: #F56C6C;"
        @click="handleDelete(scope.row)">
        删除
      </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        
        <!-- 分页 -->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background 
            :current-page="curPage"
            :page-sizes="[20, 100, 500, 1000]"
            layout="total,sizes, prev, pager, next, jumper"
            :total="totalDataNumber">
          </el-pagination>
        </div>
      </div>
    </div>
  </template>

<script>
import * as echarts from 'echarts';
import StatisticsApi from '@/api/statistics.js';
import StoreApi from '@/api/store.js';
import qs from 'qs';

export default {
  data() {
    return {
      selectedSupplier: {'name':""},
      showSupplierDropdown: false,
      startDate: this.getDefaultStartDate(),
      endDate: this.getDefaultEndDate(),
      supply:[],
      isuse:1,
      selectedSuppliers: {'store_name':""},
      showSupplierDropdowns: false,
      store:[],
      loading: true,
      tableData: [],
      storeList: [],
      form: {
        startDate: '',
        endDate: '',
        store_id: '', // 供应商ID
        search: '', // 订单号搜索
        page: 1,
        list_rows: 20
      },
      statistics: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,
      multipleSelection: [],
      dialogVisible: false,
      rejectForm: {
        pay_order_id: '',
        order_no: '',
        reject_val: ''
      }
    };
  },
  mounted() {
    this.search();
    this.loadStaticData();
    this.initCharts();
  },
  methods: {
    loadStaticData() {
  StatisticsApi.getSupply().then((res) => {
    // 在返回的供应商列表前添加"全部"选项
    this.supply = [{store_id: '', store_name: '全部'}].concat(res.data.list.data || []);
    // 默认选中"全部"
    this.selectSupplier(this.supply[0]);
  }).catch(error => {
    console.error('获取供应商列表失败:', error);
  });
},

 getDefaultStartDate() {
    const date = new Date();
    date.setMonth(date.getMonth() - 6);
    return date.toISOString().split('T')[0];
  },
  getDefaultEndDate() {
    return new Date().toISOString().split('T')[0];
  },
    
async search() {
  try {
    this.loading = true;
    
    // 构建查询参数
    const params = {
      store_id: this.form.store_id || undefined,
      search: this.form.search || undefined
    };
    
    // 只有当用户修改了日期时才传参
    if (this.form.startDate !== this.getDefaultStartDate() || 
        this.form.endDate !== this.getDefaultEndDate()) {
      params.startDate = this.form.startDate;
      params.endDate = this.form.endDate;
    }
  
    
    // 并发请求统计数据和表格数据
    const [statRes, tableRes] = await Promise.all([
      StatisticsApi.orderStatistics(params),
      StoreApi.payOrderlist({
        ...params,
        page: this.curPage,
        list_rows: this.pageSize
      }, true)
    ]);
   
    
    // 更新统计数据
    this.statistics = [
      { label: '订单总数', value: statRes.data.statistics.total_orders },
      { label: '订单总金额', value: '¥' + statRes.data.statistics.total_amount.toLocaleString(), unit: '元' },
      { label: '本月订单数', value: statRes.data.statistics.month_orders }
    ];
   
    
    // 更新图表
    this.updateCharts(statRes.data);

    
    // 更新表格数据
    this.tableData = tableRes.data.list;
    this.totalDataNumber = tableRes.data.total || 0;
    
  } catch (error) {
    console.error('获取数据失败:', error);
    this.$message.error('获取数据失败');
  } finally {
    this.loading = false;
  }
},
    handleSearchClear() {
      this.form.search = '';
      this.search();
    },
     handleDelete(row) {
      this.$confirm('确定要删除该订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        StoreApi.deleteOrder({
          order_id: row.pay_order_id
        }).then(response => {
          this.$message.success(response.msg);
          this.getTableList(); // 刷新列表
        }).catch(error => {
          this.$message.error(error.message || '删除失败');
        }).finally(() => {
          this.loading = false;
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    
    // 分页变化
    handleCurrentChange(val) {
      this.form.page = val;
      this.getTableList();
    },
    
    handleSizeChange(val) {
      this.form.page = 1;
      this.form.list_rows = val;
      this.getTableList();
    },
    
    // 获取表格数据
    getTableList() {
  this.loading = true;
  
  // 构造查询参数
  const params = {
    ...this.form,
    start_time: this.form.startDate,
    end_time: this.form.endDate,
    order_no: this.form.search,
    page: this.curPage,
    list_rows: this.pageSize
  };
  
  // 如果选择了"全部"，则不传store_id
  if (!params.store_id) {
    delete params.store_id;
  }
  
  StoreApi.payOrderlist(params, true)
    .then(data => {
      this.loading = false;
      this.tableData = data.data.list;
      this.totalDataNumber = data.data.total || 0;
    })
    .catch(error => {
      this.loading = false;
      this.$message.error('获取订单列表失败');
    });
},

// updateCharts(data) {
//   if (!data) return;

//   // 订单趋势图表
//   const orderTrendChart = echarts.init(this.$refs.orderTrendChart);
//   orderTrendChart.setOption({
//     tooltip: {
//       trigger: 'axis'
//     },
//     xAxis: {
//       type: 'category',
//       // 修改后的兼容写法
//       data: (data.order_trend && data.order_trend.xAxis && data.order_trend.xAxis.data) || []
//     },
//     yAxis: {
//       type: 'value'
//     },
//     series: [{
//       // 修改后的兼容写法
//       data: (data.order_trend && data.order_trend.series && data.order_trend.series[0] && data.order_trend.series[0].data) || [],
//       type: 'line',
//       smooth: true,
//       itemStyle: {
//         color: '#409EFF'
//       }
//     }]
//   });

//   // 支付类别图表
//   const categoryChart = echarts.init(this.$refs.categoryChart);
//   categoryChart.setOption({
//     tooltip: {
//       trigger: 'item'
//     },
//     series: [{
//       type: 'pie',
//       radius: '70%',
//       // 修改后的兼容写法
//       data: (data.payment_distribution && data.payment_distribution.series && data.payment_distribution.series[0] && data.payment_distribution.series[0].data) || [],
//       emphasis: {
//         itemStyle: {
//           shadowBlur: 10,
//           shadowOffsetX: 0,
//           shadowColor: 'rgba(0, 0, 0, 0.5)'
//         }
//       },
//       itemStyle: {
//         borderRadius: 5,
//         borderColor: '#fff',
//         borderWidth: 2
//       }
//     }]
//   });

//   // 窗口大小变化时重新调整图表大小
//   window.addEventListener('resize', () => {
//     orderTrendChart.resize();
//     categoryChart.resize();
//   });
// },

// updateCharts(data) {
//   if (!data) return;

//   // 订单趋势图表
//   this.updateChart(this.$refs.orderTrendChart, {
//     xAxis: {
//       type: 'category',
//       data: (
//         (data.order_trend && data.order_trend.xAxis && data.order_trend.xAxis.data) 
//         || []
//       )
//     },
//     yAxis: { type: 'value' },
//     series: [{
//       data: (
//         data.order_trend && 
//         data.order_trend.series && 
//         Array.isArray(data.order_trend.series) && 
//         data.order_trend.series[0] && 
//         data.order_trend.series[0].data
//       ) || [],
//       type: 'line',
//       smooth: true,
//       itemStyle: { color: '#409EFF' }
//     }],
//     tooltip: {
//       trigger: 'axis',
//       formatter: (params) => {
//         if (!params || !params[0]) return '';
//         const date = params[0].axisValue;
//         const value = params[0].data;
//         return this.form.startDate && this.form.endDate 
//           ? `日期: ${date}<br/>订单数: ${value}`
//           : `月份: ${date}<br/>订单数: ${value}`;
//       }
//     }
//   });

//   // 支付类别图表
//   const paymentData = (
//     data.payment_distribution && 
//     data.payment_distribution.series && 
//     Array.isArray(data.payment_distribution.series) && 
//     data.payment_distribution.series[0] && 
//     data.payment_distribution.series[0].data
//   ) || [];
  
//   if (paymentData.length > 0) {
//     this.updateChart(this.$refs.categoryChart, {
//       series: [{
//         type: 'pie',
//         radius: '70%',
//         data: paymentData,
//         label: {
//           formatter: '{b}: {c} ({d}%)'
//         },
//         emphasis: {
//           itemStyle: {
//             shadowBlur: 10,
//             shadowOffsetX: 0,
//             shadowColor: 'rgba(0, 0, 0, 0.5)'
//           }
//         }
//       }],
//       tooltip: {
//         trigger: 'item',
//         formatter: '{a} <br/>{b}: {c} ({d}%)'
//       }
//     });
//   } else {
//     this.showNoDataPrompt(this.$refs.categoryChart, '暂无支付数据');
//   }
// },

// updateChart 和 showNoDataPrompt 方法保持不变
updateChart(chartDom, option) {
  let chart = echarts.getInstanceByDom(chartDom);
  if (!chart) {
    chart = echarts.init(chartDom);
  }
  chart.setOption(option, true); // true表示不合并旧配置
  chart.resize();
},

// async search() {
//   try {
//     this.loading = true;
    
//     // 构建查询参数
//     const params = {
//       store_id: this.form.store_id || undefined,
//       search: this.form.search || undefined
//     };
    
//     // 只有当用户修改了日期时才传参
//     if (this.form.startDate !== this.getDefaultStartDate() || 
//         this.form.endDate !== this.getDefaultEndDate()) {
//       params.startDate = this.form.startDate;
//       params.endDate = this.form.endDate;
//     }
    
//     // 并发请求
//     const [statRes, tableRes] = await Promise.all([
//       StatisticsApi.orderStatistics(params),
//       StoreApi.payOrderlist({
//         ...params,
//         page: this.curPage,
//         list_rows: this.pageSize
//       }, true)
//     ]);
    
//     // 更新数据
//     this.updateStatistics(statRes.data);
//     this.updateCharts(statRes.data);
//     this.tableData = tableRes.data.list;
//     this.totalDataNumber = tableRes.data.total || 0;
    
//   } catch (error) {
//     console.error('获取数据失败:', error);
//     this.$message.error('获取数据失败');
//   } finally {
//     this.loading = false;
//   }
// },


async search() {
  try {
    this.loading = true;
    
    // 构建查询参数
    const params = {
      store_id: this.form.store_id || undefined,
      search: this.form.search || undefined
    };
    
    // 只有当用户修改了日期时才传参
    if (this.form.startDate !== this.getDefaultStartDate() || 
        this.form.endDate !== this.getDefaultEndDate()) {
      params.startDate = this.form.startDate;
      params.endDate = this.form.endDate;
    }
    
    // 并发请求
    const [statRes, tableRes] = await Promise.all([
      StatisticsApi.orderStatistics(params),
      StoreApi.payOrderlist({
        ...params,
        page: this.curPage,
        list_rows: this.pageSize
      }, true)
    ]);
    
    // 更新数据
    this.updateStatistics(statRes.data);
    this.updateCharts(statRes.data);
    this.tableData = tableRes.data.list;
    this.totalDataNumber = tableRes.data.total || 0;
    
  } catch (error) {
    console.error('获取数据失败:', error);
    this.$message.error('获取数据失败');
  } finally {
    this.loading = false;
  }
},
updateStatistics(data) {
  this.statistics = [
    { label: '订单总数', value: data.statistics.total_orders },
    { 
      label: '订单总金额', 
      value: '¥' + parseFloat(data.statistics.total_amount).toLocaleString(),
      unit: '元' 
    },
    { label: '本月订单数', value: data.statistics.month_orders }
  ];
},

updateCharts(data) {
  // 订单趋势图表
  this.updateChart(this.$refs.orderTrendChart, {
    xAxis: {
      type: 'category',
      data: (
        (data.order_trend && 
          data.order_trend.xAxis && 
          data.order_trend.xAxis.data) 
        || []
      )
    },
    yAxis: { type: 'value' },
    series: [{
      data: (
        data.order_trend && 
        data.order_trend.series && 
        Array.isArray(data.order_trend.series) && 
        data.order_trend.series[0] && 
        data.order_trend.series[0].data
      ) || [],
      type: 'line',
      smooth: true,
      itemStyle: { color: '#409EFF' }
    }],
    tooltip: {
      trigger: 'axis',
      formatter: (params) => {
        if (!params || !params[0]) return '';
        const date = params[0].axisValue;
        const value = params[0].data;
        return this.form.startDate && this.form.endDate 
          ? `日期: ${date}<br/>订单数: ${value}`
          : `月份: ${date}<br/>订单数: ${value}`;
      }
    }
  });

  // 支付类别图表
  const paymentData = (
    data.payment_distribution && 
    data.payment_distribution.series && 
    Array.isArray(data.payment_distribution.series) && 
    data.payment_distribution.series[0] && 
    data.payment_distribution.series[0].data
  ) || [];
  
  console.log(paymentData.length);
  

  if (paymentData.length > 0) {
    this.updateChart(this.$refs.categoryChart, {
      series: [{
        type: 'pie',
        radius: '70%',
        data: paymentData,
        label: { formatter: '{b}: {c} ({d}%)' },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }],
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      }
    });
  } else {
    this.showNoDataPrompt(this.$refs.categoryChart, '暂无支付数据');
  }
},

updateStatistics(data) {
  const stats = (data.statistics || {});
  this.statistics = [
    { 
      label: '订单总数', 
      value: stats.total_orders || 0 
    },
    { 
      label: '订单总金额', 
      value: '¥' + (stats.total_amount ? parseFloat(stats.total_amount).toLocaleString() : '0.00'),
      unit: '元' 
    },
    { 
      label: '本月订单数', 
      value: stats.month_orders || 0 
    }
  ];
},

showNoDataPrompt(chartDom, text) {
  const chart = echarts.init(chartDom);
  chart.setOption({
    graphic: {
      elements: [{
        type: 'text',
        left: 'center',
        top: 'middle',
        style: {
          text: text,
          fontSize: 14,
          fill: '#999',
          fontWeight: 'bold'
        }
      }]
    }
  });
},
    
initCharts(data) {
  if (!data) return;

  // 订单趋势图表
  const orderTrendChart = echarts.init(this.$refs.orderTrendChart);
  orderTrendChart.setOption({
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      type: 'category',
      // 修改后的兼容写法
      data: (data.order_trend && data.order_trend.xAxis && data.order_trend.xAxis.data) || []
    },
    yAxis: {
      type: 'value'
    },
    series: [{
      // 修改后的兼容写法
      data: (data.order_trend && data.order_trend.series && data.order_trend.series[0] && data.order_trend.series[0].data) || [],
      type: 'line',
      smooth: true,
      itemStyle: {
        color: '#409EFF'
      }
    }]
  });

  // 支付类别图表
  const categoryChart = echarts.init(this.$refs.categoryChart);
  categoryChart.setOption({
    tooltip: {
      trigger: 'item'
    },
    series: [{
      type: 'pie',
      radius: '70%',
      // 修改后的兼容写法
      data: (data.payment_distribution && data.payment_distribution.series && data.payment_distribution.series[0] && data.payment_distribution.series[0].data) || [],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      },
      itemStyle: {
        borderRadius: 5,
        borderColor: '#fff',
        borderWidth: 2
      }
    }]
  });

  // 窗口大小变化时重新调整图表大小
  window.addEventListener('resize', () => {
    orderTrendChart.resize();
    categoryChart.resize();
  });
},

    
    getTableList() {
      let self = this;
      let Params = self.form;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      
      StoreApi.payOrderlist(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list;
          self.totalDataNumber = data.data.list.total || 0;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
    
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },
    
    handleRefund(row) {
      this.$confirm('确定要退款吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        StoreApi.approveRefund({
          order_id: row.pay_order_id
        }).then(response => {
          this.$message.success(response.msg);
          this.getTableList();
        }).catch(error => {
          this.$message.error(error.message || '退款失败');
        });
      }).catch(() => {
        this.$message.info('已取消退款');
      });
    },
    
    getPayTypeText(type) {
      const payTypeMap = {
        10: '余额',
        20: '微信',
        30: '支付宝',
        40: '花呗',
        50: 'app微信',
        60: 'app支付宝'
      };
      return payTypeMap[type] || type; 
    },
    
    getPayStatusText(status) {
      const statusMap = {
        10: '待支付',
        20: '已支付',
        30: '退还已返还',
      };
      return statusMap[status] || status;
    },
    
    toggleSupplierDropdown() {
      this.showSupplierDropdown = !this.showSupplierDropdown;
    },
    
   // 选择供应商
   selectSupplier(supplier) {
      this.selectedSupplier = supplier;
      this.showSupplierDropdown = false;
      this.form.store_id = supplier.store_id;
      this.search(); // 选择后自动查询
    },
  }
};
</script>

<style scoped>
/* 移除number input的箭头 */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}

.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
}
/* 图表容器样式 */
.echarts {
  width: 100%;
  height: 100%;
}

/* 筛选下拉菜单样式 */
.supplier-dropdown {
  max-height: 300px;
  overflow-y: auto;
}

/* 全部选项特殊样式 */
.all-option {
  font-weight: bold;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
  margin-bottom: 4px;
}
</style>


// WEBPACK FOOTER //
// src/views/statistics/store/store.vue